/* Copyright (C) 2018 TeselaGen Biotechnology, Inc. */
import { compose, withHandlers } from "recompose";
import { connect } from "react-redux";
import { change, initialize } from "redux-form";
export default function (_tableFormName, propName) {
  var _withHandlers;

  if (propName === void 0) {
    propName = "selectTableRecords";
  }

  return compose(connect(null, {
    changeFormValue: change,
    initializeForm: initialize
  }), withHandlers((_withHandlers = {}, _withHandlers[propName] = function (props) {
    return function (_records) {
      if (_records === void 0) {
        _records = [];
      }

      var tableFormName = _tableFormName;

      if (typeof _tableFormName === "function") {
        tableFormName = _tableFormName(props);
      } // initialize if needed so that the values will stay


      props.initializeForm(tableFormName, {}, true, {
        keepDirty: true,
        updateUnregisteredFields: true,
        keepValues: true
      });
      var selectedEntityIdMap = {};
      var records = _records;
      if (_records && !Array.isArray(_records)) records = [records];
      records.forEach(function (record) {
        selectedEntityIdMap[record.id] = {
          entity: record
        };
      });
      props.changeFormValue(tableFormName, "reduxFormSelectedEntityIdMap", selectedEntityIdMap);
    };
  }, _withHandlers)));
}